import MvtMovementList from '@/modules/movement/views/MvtMovementList';
import MvtMovement from '@/modules/movement/views/MvtMovement';
import MvtAccount from '@/modules/movement/views/MvtAccount';
import MvtFinancialStatementList from '@/modules/movement/views/MvtFinancialStatementList';
import MvtFinancialStatement from '@/modules/movement/views/MvtFinancialStatement';

import MvtPaymentList from '@/modules/movement/views/MvtPaymentList';
import MvtPayment from '@/modules/movement/views/MvtPayment';

import MvtInventoryList from '@/modules/movement/views/MvtInventoryList';
import MvtInventory from '@/modules/movement/views/MvtInventory';

import MvtRefundList from '@/modules/movement/views/MvtRefundList';
import MvtRefund from '@/modules/movement/views/MvtRefund';
import MvtRefundItemList from '@/modules/movement/views/MvtRefundItemList';

export default [
	{
		path: '/mvtmovementlist',
		name: 'mvtmovementlist',
		component: MvtMovementList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/movement/add/:typeMvt/:typeDep/:accId/:typeAdd',
		name: 'mvtmovement',
		component: MvtMovement,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/movement/show/:itemId',
		name: 'mvtmovementshow',
		component: MvtMovement,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	
	{
		path: '/mvtaccount',
		name: 'mvtaccount',
		component: MvtAccount,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/mvtfinancialstatement',
		name: 'mvtfinancialstatement',
		component: MvtFinancialStatementList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/mvtfinancialstatement/show/:itemId',
		name: 'mvtfinancialstatementshow',
		component: MvtFinancialStatement,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},

	{
		path: '/mvtpayment',
		name: 'mvtpayment',
		component: MvtPaymentList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/payment/add/:typePay/:prsId/:storeId',
		name: 'mvtpaymentadd',
		component: MvtPayment,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/payment/show/:itemId',
		name: 'mvtpaymentshow',
		component: MvtPayment,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/mvtinventory',
		name: 'mvtinventory',
		component: MvtInventoryList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/inventory/show/:itemId',
		name: 'mvtinventoryshow',
		component: MvtInventory,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/inventory/add',
		name: 'mvtinventoryadd',
		component: MvtInventory,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/mvtrefund',
		name: 'mvtrefund',
		component: MvtRefundList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/refund/show/:itemId',
		name: 'mvtrefundshow',
		component: MvtRefund,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/refund/add',
		name: 'mvtrefundadd',
		component: MvtRefund,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/mvtrefunditem',
		name: 'mvtrefunditem',
		component: MvtRefundItemList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},

]